<template>
  <v-select
    v-model="selected"
    label="User Type"
    :items="items"
    :loading="isLoading"
    outlined
    dense
    clearable
    item-text="name"
    item-value="value"
  />
</template>

<script>
export default {
  name: "AppUserTypesAutocomplete",
  data: () => ({
    isLoading: false,
    items: [
      { id: 1, name: "Login", value: 0 },
      { id: 2, name: "Guess", value: 1 },
    ],
    selected: "",
  }),
  watch: {
    selected: function () {
      this.$emit("input", this.selected);
    },
  },
};
</script>
